import {
  PersonAdd as AddUserIcon,
  Login as LoginIcon,
  GridView as UserGridIcon,
} from "@mui/icons-material";
import DashboardIcon from "./Dashboard";
import ScheduleIcon from "./ScheduleIcon";
import SessionsIcon from "./Sessions";
import UserManagementIcon from "./UserManagement";
import UserProfileIcon from "./UserProfile";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  LoginIcon,
  AddUserIcon,
  SessionsIcon,
  UserGridIcon,
  DashboardIcon,
  UserProfileIcon,
  UserManagementIcon,
  ScheduleIcon,
};
